import { PropsWithChildren, ReactElement } from 'react';
import styles from './ElementList.module.scss';

export const ElementList = ({ children }: PropsWithChildren): ReactElement => {
  return <span className={styles.elementContainer}>{children}</span>;
};

export default ElementList;
